import React from 'react';
import {  Col, Card } from 'react-bootstrap';
import './flatstyledcard.scss';

const FlatStyledSingle = ({membershipPrice = 20, discount = 5, total = 15}) => {
  return (

          <Card className="flat-card">
            <Card.Body>
              <div className="membership-section">
                <h5>GA Meet Influencer Event Ticket Price</h5>
                <p>${membershipPrice}</p>
              </div>
              <div className="discount-section">
                <h5>Discount</h5>
                <p>-${discount.toFixed(2)}</p>
              </div>
              <div className="total-section">
                <h5>Total (One-Time)</h5>
                <p>${total.toFixed(2)}</p>
              </div>
            </Card.Body>
          </Card>



  );
};

export default FlatStyledSingle;